import { NextRouter } from 'next/router';

import { IAvailabilitySearchQueryInstance } from '@/availability/models';
import { AmendBookingRequest } from '@/booking-management';
import {
  getAmendBookingAdditionalInformationUrl,
  getAmendBookingAvailabilityUrlFromQueryInstance,
  getAmendBookingConfirmChangesUrl,
  getAmendBookingConfirmationUrl,
  getAmendBookingExpiredUrl,
  getAmendBookingPaymentPendingUrl,
  getAmendBookingPaymentUrl,
  getManageBookingUrl,
} from '@/booking-management/urls';

import { AmendBookingCheckoutNavigator } from '../interfaces';

export const createAmendBookingCheckoutNavigator = ({
  request,
  query,
  router,
  operaId,
}: {
  request: AmendBookingRequest;
  query?: IAvailabilitySearchQueryInstance;
  router: NextRouter;
  operaId?: string;
}): AmendBookingCheckoutNavigator => {
  /**
   * Returns a function which when called, calls router.push with the result of the given function.
   * @param urlFn
   * @returns
   */
  const navigate = (urlFn: (request: AmendBookingRequest) => string) => () =>
    router.push(urlFn(request));

  return {
    additionalInformationPage: navigate(
      getAmendBookingAdditionalInformationUrl
    ),
    expiredPage: navigate(getAmendBookingExpiredUrl),
    paymentPage: navigate(getAmendBookingPaymentUrl),
    pendingPage: navigate(getAmendBookingPaymentPendingUrl),
    confirmationPage: navigate(getAmendBookingConfirmationUrl),
    compareChangesPage: navigate(getAmendBookingConfirmChangesUrl),
    manageBookingPage: () => router.push(getManageBookingUrl(operaId)),
    searchResultsPage: () =>
      router.push(
        getAmendBookingAvailabilityUrlFromQueryInstance({
          query,
          oldBooking: request.oldBooking,
        })
      ),
  };
};
